(function ($) {
    $(document).on('click.popup-contact-us', '[data-popup-contact-us__trigger]', function() {
        this.closest('[data-popup-contact-us]').classList.add(this.getAttribute('data-popup-contact-us__trigger'));
    });
}(jQuery));
